<template>
  <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.7461 20.4922L2.00005 10.7461L11.7461 1.00003"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
